// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4b82b1e3","488":"cc7f7ab1","759":"a93814bf"}[chunkId] + ".chunk.js";
};